<template>
	<link-button node="div" type="line" :color="focus?'primary':'info'" class="link-dynamic-filter-number" :class="{'link-dynamic-filter-number-focus':focus}">
		<div class="link-input-prefix-icon" v-if="!!searchIcon">
			<link-icon icon="link-icon-search"/>
		</div>
		<link-input-number type="none" :showIcon="false" :placeholder="$t('LinkFilter.minValue')" @focus="lv_focus" @blur="lv_blur" hideClearIcon @enter="lv_enter" ref="start" :value="dynamicFilter.value.start"/>
		<span>{{$t('LinkForm.to')}}</span>
		<link-input-number type="none" :showIcon="false" :placeholder="$t('LinkFilter.maxValue')" @focus="lv_focus" @blur="lv_blur" hideClearIcon @enter="lv_enter" ref="end" :value="dynamicFilter.value.end"/>
	</link-button>
</template>

<script>
    import {DynamicFilterMixin} from "../link-dynamic-filter";

    export default {
        name: "link-dynamic-filter-number",
        mixins: [DynamicFilterMixin],
        data() {
            return {
                timer: null,
                focus: false,
            }
        },
        methods: {
            getValue() {
                const start = this.$refs.start.$refs.input.$refs.input.value
                const end = this.$refs.end.$refs.input.$refs.input.value
                this.dynamicFilter.value = {start, end}
            },
            lv_enter() {
                this.confirm()
            },
            lv_focus() {
                if (!!this.timer) {
                    clearTimeout(this.timer)
                    this.timer = null
                }
                this.timer = setTimeout(() => {
                    this.focus = true
                }, 23)
            },
            lv_blur() {
                if (!!this.timer) {
                    clearTimeout(this.timer)
                    this.timer = null
                }
                this.timer = setTimeout(() => {
                    this.focus = false
                }, 0)
            },
        }
    }
</script>

<style lang="scss">
	.link-dynamic-filter-number {
		display: flex;
		color: $icon-color !important;
		padding: 0 6px !important;
		justify-content: space-between;

		.link-input-prefix-icon {
			width: 1em;
			font-size: 11px;
		}

		.link-input-number {
			border: none !important;
			outline: none !important;
			input {
				text-align: center !important;
			}
		}
	}
</style>